module.exports = __webpack_public_path__ + "static/img/A63.02dc1709.jpg";